import React, { useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { UserOutlined, TrophyOutlined, MenuOutlined, CloseOutlined } from '@ant-design/icons';

const MasterPage = () => {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-900 text-white flex flex-col">
      {/* Header */}
      <header className="bg-gray-800 shadow-md py-4 px-6 flex flex-row items-center justify-between relative">
        {/* Logo */}
        <div className="text-white text-xl font-bold">
          LVLMANIA
        </div>
        {/* Nav + Hamburger (right side) */}
        <div className="flex items-center">
          {/* Hamburger Menu Button (Mobile) */}
          <button
            className="md:hidden text-gray-300 hover:text-white focus:outline-none"
            onClick={() => setNavOpen(!navOpen)}
            aria-label={navOpen ? "Close navigation menu" : "Open navigation menu"}
          >
            {navOpen ? <CloseOutlined /> : <MenuOutlined />}
          </button>
          {/* Navigation Menu */}
          <nav
            className={`
              flex-col absolute top-full left-0 w-full bg-gray-800 z-10 shadow-md
              md:static md:flex md:flex-row md:space-x-4 md:bg-transparent md:shadow-none
              ${navOpen ? 'flex' : 'hidden'} md:flex
            `}
          >
            <Link
              to="/"
              className="text-gray-300 hover:text-white flex items-center px-6 py-3 md:p-0 border-b border-gray-700 md:border-none"
              onClick={() => setNavOpen(false)}
            >
              <UserOutlined className="mr-2" />
              Home
            </Link>
            <Link
              to="/bunny-escape"
              className="text-gray-300 hover:text-white flex items-center px-6 py-3 md:p-0 border-b border-gray-700 md:border-none"
              onClick={() => setNavOpen(false)}
            >
              <TrophyOutlined className="mr-2" />
              Bunny Escape
            </Link>
            <Link
              to="/2357-prime"
              className="text-gray-300 hover:text-white flex items-center px-6 py-3 md:p-0 border-b border-gray-700 md:border-none"
              onClick={() => setNavOpen(false)}
            >
              <TrophyOutlined className="mr-2" />
              2357 Prime
            </Link>
            <Link
              to="/prime-path"
              className="text-gray-300 hover:text-white flex items-center px-6 py-3 md:p-0 border-b border-gray-700 md:border-none"
              onClick={() => setNavOpen(false)}
            >
              <TrophyOutlined className="mr-2" />
              Prime Path App
            </Link>
            {/* <Link
              to="/bunny-hop"
              className="text-gray-300 hover:text-white flex items-center px-6 py-3 md:p-0 border-b border-gray-700 md:border-none"
              onClick={() => setNavOpen(false)}
            >
              <TrophyOutlined className="mr-2" />
              Bunny Hop
            </Link> */}
            <Link
              to="/about"
              className="text-gray-300 hover:text-white flex items-center px-6 py-3 md:p-0"
              onClick={() => setNavOpen(false)}
            >
              <UserOutlined className="mr-2" />
              About
            </Link>
          </nav>
        </div>
      </header>

      {/* Content */}
      <main className="flex-grow py-8 px-6">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 p-4 text-center text-sm rounded-t-lg shadow-inner">
        &copy;2025 LVLMANIA. All Rights Reserved.
      </footer>
    </div>
  );
};

export default MasterPage;